<template>
  <div>
    <table-title>转户办理信息</table-title>
    <Form ref="deliver" :model="deliver" :label-width="140" inline :rules="deliverRules">
      <FormItem label="转出方：" prop="deliverOutLeaseeId">
        <!-- <payee-select class="shrug" roleType="LEASEE" v-model="deliver.deliverOutLeaseeId" :disabled="!outMemberEdit"></payee-select> -->
        <payee-select class="shrug" roleType="LEASEE" v-model="deliver.deliverOutLeaseeId"></payee-select>
      </FormItem>
      <FormItem label="转出部门：" prop="deliverOutZoneId" v-if="deliver.deliverOutLeaseeId">
        <bizSelect v-model="deliver.deliverOutZoneId" url="http://CORE-MEMBER/messageService/respZoneService/queryRespZoneByMemberId" :params="{memberId:deliver.deliverOutLeaseeId}" codeField="respZoneId" style="width:185px" />
      </FormItem>
      <br />
      <FormItem label="接收方编号：" prop="deliverInLeaseeId">
        <Input v-model="deliver.deliverInLeaseeId" style="width:200px" />
      </FormItem>
      <FormItem label="接收方名称：" prop="deliverInLeaseeName">
        <Input v-model="deliver.deliverInLeaseeName" style="width:200px" />
      </FormItem>
      <Button type="primary" size="small" @click="historyView=true">历史</Button>
      <br />
      <FormItem label="标的物小类：" prop="targetType">
        <Select v-model="deliver.targetType" style="width:200px" filterable clearable label-in-value>
          <Option v-for="item in targetList" :value="item.code" :key="item.id">{{ item.text }}</Option>
        </Select>
      </FormItem>
      <FormItem label="转户数量" prop="amount">
        <InputNumber v-model="deliver.amount" :min="1" :precision="0" style="width:200px" />
      </FormItem>
      <br />
      <FormItem label="转出时间">
        <DatePicker :value="deliver.deliverOutDate" type="date" placeholder="Select date" style="width: 200px" @on-change="(val)=>deliver.deliverOutDate = val"></DatePicker>
      </FormItem>
      <FormItem label="转户协议：" prop="deliverAgreementName" v-if="show">
        <Input :value="deliver.deliverAgreementName" placeholder="不填则常规转户" style="width:200px" disabled />
      </FormItem>
      <Button type="success" @click="openModal" :disabled="!deliver.deliverOutLeaseeId||!deliver.targetType||!deliver.deliverInLeaseeId">选择</Button>
      <Button type="default" @click="clearAgreement" style="margin-left:10px">清空</Button>
      <br />
      <FormItem label="交接地址">
        <addr-cascader v-model="deliver.deliverAreaId" />
      </FormItem>

      <Button type="success" size="small" @click="onQueryAdress" style="margin-left:10px" :loading="loading" :disabled="!deliver.deliverInLeaseeId || !deliver.deliverInLeaseeName">选择</Button>

      <FormItem label="交接详细地址">
        <Input v-model="deliver.deliverAddress" style="width:200px" />
        <recognize-region :address="deliver.deliverAddress" @onRecognize="onRecognize" />
      </FormItem>
      <br>
      <FormItem label="备注信息">
        <Input v-model="deliver.remark" type="textarea" style="width:490px" />
      </FormItem>
    </Form>
    <table-title>
      合约选择
      <plt-biz-select v-model="deliver.fromMember" :transfer="false" url="http://MID-OPERATE-LEASE/messageService/deliverService/queryDeliverOutLeaseeList" :params="{memberId:deliver.deliverOutLeaseeId}" placeholder="合约上游(非必选)" style="width: 200px" />
      <Button size="small" type="primary" @click="openContractModal" :disabled="!deliver.deliverOutLeaseeId||!deliver.targetType||!deliver.deliverOutDate">选择</Button>
      <Button size="small" type="success" style="margin-left:5px" :loading="btnLoading" @click="onAuto" :disabled="!deliver.deliverOutLeaseeId||!deliver.targetType||!deliver.deliverOutDate ||!deliver.amount">自动匹配</Button>
    </table-title>
    <Table :columns="cols" :data="contractList">
      <template slot-scope="{ index }" slot="action">
        <Button type="error" @click="removeLog(index)">删除</Button>
      </template>
      <template slot-scope="{ row }" slot="modelId">{{$options.filters['queryDict']('default','billingModel',row.modelId)}}</template>
      <template slot-scope="{ row }" slot="leaserId">{{$options.filters['queryDict']('bizObjects','member',row.leaserId)}}</template>
      <template slot-scope="{ row }" slot="rentWay">{{$options.filters['queryDict']('ENUM_CORE-CONTRACT','contractEntity.RentWay',row.rentWay||'-')}}</template>
      <template slot-scope="{ row }" slot="fromMemberId">{{$options.filters['queryDict']('bizObjects','member',row.fromMemberId||'-')}}</template>
    </Table>

    <tableTitle style="margin-top:20px">附件上传</tableTitle>
    <pipUpload @success="onSuccess" @delete="onDelete"></pipUpload>

    <div style="text-align:center;width:700px;margin:30px">
      <Button type="success" style="margin-left:20px" @click="commit">提交</Button>
      <Button type="warning" style="margin-left:20px" @click="back">返回</Button>
    </div>

    <Modal v-model="historyView" title="历史接收客户">
      <bizSelect v-if="historyView" url="http://MID-OPERATE-LEASE/messageService/deliverService/queryDeliverInLeaseeList" :params="{memberId:deliver.deliverOutLeaseeId}" style="width:185px" @onItemChange="selectHistoryMember" />
      <div slot="footer">
        <Button type="primary" @click="confirmSelect">确认</Button>
      </div>
    </Modal>
    <query-area ref="queryAreaRef" @onRow="onRow"></query-area>
    <contractSelectModal ref="contractSelect" :queryParams="{leaseeId:deliver.deliverOutLeaseeId,targetType:deliver.targetType,billingStopDate:deliver.deliverOutDate,groupFlag:deliver.deliverOutZoneId,fromMember:deliver.fromMember}" @onFinish="selectContract" />
    <frameTransModal ref="frameTransModal" :queryParams="{fromMemberId:deliver.deliverOutLeaseeId,toMemberId:deliver.deliverInLeaseeId,targetType:deliver.targetType}" @onFinish="selectAgreement" />
  </div>
</template>

<script>
import tableTitle from "@/components/tableTitle/tableTitle.vue";
import payeeSelect from "@/components/select/payee-select.vue";
import targetTypeCascader from "@/components/select/targetType-cascader.vue";
import frameTransModal from "./component/frame-trans-modal.vue";
import contractSelectModal from "./component/contract-select-modal.vue";
import bizSelect from "@/components/select/biz-select.vue";
import pipUpload from "@/components/upload/upload.vue";

import addrCascader from "_c/select/addr-cascader.vue";
import queryArea from "views/user-center/lease/leaseTransact/compoent/queryArea.vue";
export default {
  components: {
    tableTitle,
    payeeSelect,
    targetTypeCascader,
    frameTransModal,
    contractSelectModal,
    bizSelect,
    pipUpload,
    queryArea,
    addrCascader,
  },
  props: ["deliverInfo"],
  data() {
    return {
      targetList: [],
      leaseeShow: false,
      loading: false,
      deliver: {
        deliverOutLeaseeId: undefined,
        deliverInLeaseeName: "",
        deliverAgreementName: "",
        amount: "",
        deliverInLeaseeId: "",
        deliverOutDate: new Date().toISOString().substring(0, 10),
        deliverAddress: "", //交接详细地址
        deliverAreaId: "", //省市区
        fromMember : ""
      },
      deliverRules: {
        deliverOutLeaseeId: [
          { required: true, message: "请选择转出方", trigger: "blur" },
        ],
        targetType: [
          { required: true, message: "请选择标的物小类", trigger: "blur" },
        ],
        deliverInLeaseeId: [{ required: true, message: "请填写接收方ID" }],
        deliverInLeaseeName: [{ required: true, message: "请填写接收方名称" }],
        amount: [
          {
            required: true,
            type: "number",
            message: "请填写转户数量",
            trigger: "blur",
          },
        ],
      },
      contractList: [],
      cols: [
        { title: "合约编号", key: "id" },
        { title: "剩余计租数", key: "remainAmount" },
        { title: "租借人归还开放日", key: "leaseeMinBillingStopDate" },
        { title: "模式类型", slot: "modelId" },
        // {title: '模式类型', key: 'modelId', dict: ['default', 'billingModel'] },
        { title: "接收日期", key: "deliveredDate" },
        { title: "租期", key: "rentTerm" },
        { title: "起始数量", key: "amount" },
        { title: "合伙人", slot: "leaserId" },
        { title: "合约类型", slot: "rentWay" },
        { title: '上游', slot: "fromMemberId"},
        { title: '备注', key: "remark" },
        // {title: '合伙人', key: 'leaserId', dict: ['bizObjects', 'member',true] },
        { title: "办理", slot: "action" },
      ],
      outMemberEdit: false,
      historyView: false,
      selectedMember: {},
      imgList: [],
      show: true,
    };
  },
  async mounted() {
    // this.getMemberId();
    if (this.deliverInfo.deliverOutLeaseeId) {
      this.deliver.deliverOutLeaseeId = this.deliverInfo.deliverOutLeaseeId;
      this.outMemberEdit = false;
    }
    await this.dict.initDict([
      { id: "billingModel", namespace: "default" },
      { id: "member", namespace: "bizObjects" },
      { id: "contractEntity.RentWay", namespace: "ENUM_CORE-CONTRACT" },
    ]); // 初始化字典
  },
  watch: {
    "deliver.deliverOutLeaseeId": function (newVal, oldVal) {
      if (!newVal) {
        this.contractList = [];
      } else {
        this.getTargetList(newVal);
      }
    },
    "deliver.deliverInLeaseeId": function (newVal, oldVal) {
      setTimeout(() => {
        if (newVal != this.deliver.deliverInLeaseeId) return;
        if (!newVal) {
          this.deliver.deliverAgreementName = "";
          this.deliver.deliverAgreementCode = "";
        } else {
          this.queryNeedDlvFrame();
        }
      }, 500);
    },
    "deliver.targetType": function (newVal, oldVal) {
      if (!newVal) {
        this.contractList = [];
      }
    },
    "deliver.deliverOutDate": function (newVal, oldVal) {
      if (!newVal) {
        this.contractList = [];
      }
    },
  },
  methods: {
    // 自动识别
    onRecognize({ regionCode, address }) {
        this.deliver.deliverAddress = address;
      this.deliver.deliverAreaId = regionCode;
    },
    queryNeedDlvFrame() {
      this.show = false;
      let rule = new Array();
      rule[0] = { required: true, message: "请选择转户协议" };
      let params = {
        url: "http://MID-OPERATE-LEASE/messageService/deliverService/needDlvFrame",
        body: {
          fromMemberId: this.deliver.deliverOutLeaseeId,
          toMemberId: this.deliver.deliverInLeaseeId,
        },
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.deliverRules.deliverAgreementName = rule;
        } else {
          delete this.deliverRules.deliverAgreementName;
        }
        this.show = true;
      });
    },
    // 自动匹配合约
    onAuto() {
      this.contractList = [];
      let data = {
        url: "http://MID-OPERATE-LEASE/messageService/recycleService/queryContractListToStopBilling",
        body: {
          params: {
            leaseeId: this.deliver.deliverOutLeaseeId,
            targetType: this.deliver.targetType,
            billingStopDate: this.deliver.deliverOutDate,
            groupFlag: this.deliver.deliverOutZoneId,
            fromMember: this.deliver.fromMember
          },
        },
      };
      this.btnLoading = true;
      this.invoke(data)
        .then((res) => {
          if (!res.length){
            this.btnLoading = false;
            return this.$Message.warning("暂无匹配合约");
          } 
          let autoContract = [];
          this.btnLoading = false;
          autoContract = JSON.parse(JSON.stringify(res));
          var amount = this.deliver.amount; //10

          autoContract.forEach((item) => {
            let quantity = Math.min(amount, item.remainAmount);
            item._check = quantity;
            amount -= quantity;
          });
          this.contractList = autoContract.filter((ele) => ele._check);
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
    // 校验接收方编号和接收方名称是否对应
    checkDeliver(id, name) {
      let data = {
        url: "http://MID-OPERATE-LEASE/messageService/deliverService/checkDeliverInLeasee",
        body: { id, name },
      };
      this.loading = true;
      this.invoke(data)
        .then((res) => {
          this.leaseeShow = true;
          this.loading = false;
        })
        .catch((err) => {
          this.leaseeShow = false;
          this.loading = false;
        });
    },
    // 选择地址
    onQueryAdress() {
      this.checkDeliver(
        this.deliver.deliverInLeaseeId,
        this.deliver.deliverInLeaseeName
      );
      if (!this.leaseeShow) return;
      this.$refs["queryAreaRef"].openModal(this.deliver.deliverInLeaseeId);
    },
    onRow(row) {
      this.deliver.deliverAreaId = row.areaId;
      this.deliver.deliverAddress = row.address;
    },
    // 标的物小类数据
    async getTargetList(leaseeId) {
      this.targetList = [];
      let data = {
        url: "CORE-CONTRACT/messageService/contractService/queryTargetTypesByLeaseeContracts",
        body: { leaseeId },
      };
      this.targetList = await this.invoke(data);
    },
    getMemberId() {
      let userId = sessionStorage.getItem("userId");
      let params = {
        url: "http://CORE-MEMBER/messageService/baseInfoService/queryMemberIdByUserId",
        body: { userId: userId },
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.deliver.deliverOutLeaseeId = rs.memberId;
        }
      });
    },
    clearAgreement() {
      this.deliver.deliverAgreementCode = "";
      this.deliver.deliverAgreementName = "";
      delete this.deliver.deliverAgreementCode;
    },
    openModal() {
      this.$refs["frameTransModal"].openModal();
    },
    openContractModal() {
      this.$refs["contractSelect"].openModal();
    },
    selectAgreement(val) {
      this.deliver.deliverAgreementCode = val.id;
      this.deliver.deliverAgreementName = val.name;
    },
    selectContract(selection) {
      selection.forEach((item) => {
        if (this.contain(item) == false) {
          this.contractList.push(item);
        }
      });
    },
    contain(element) {
      let contain = false;
      this.contractList.forEach((e) => {
        if (e.id == element.id) {
          contain = true;
        }
      });
      return contain;
    },
    removeLog(index) {
      this.contractList.splice(index, 1);
    },
    selectHistoryMember(val) {
      this.selectedMember.id = val.id;
      this.selectedMember.name = val.name;
    },
    confirmSelect() {
      this.deliver.deliverInLeaseeId = this.selectedMember.id;
      this.deliver.deliverInLeaseeName = this.selectedMember.name;
      this.historyView = false;
    },
    onSuccess(rs) {
      this.imgList.push(rs.body);
    },
    onDelete(rs) {
      let index = this.imgList.indexOf(rs.id);
      this.imgList.splice(index, 1);
    },
    async commit() {
      let valid = await this.$refs["deliver"].validate();
      if (!valid) return;
      let contractList = this.contractList.map((item) => {
        return item.id;
      });
      let params = {
        url: "http://MID-OPERATE-LEASE/messageService/deliverService/commitDeliverOrder",
        body: {
          deliver: this.deliver,
          contractList: contractList,
          imgList: this.imgList,
        },
      };
      this.invoke(params).then((rs) => {
        if (rs) {
          this.$Message.info("添加成功");
          this.back();
        }
      });
    },
    back() {
      this.$emit("on-finish", {});
    },
  },
};
</script>